import type {
    RouteLocationNormalizedLoaded,
    RouteLocationRaw,
} from "vue-router";

/**
 * Where closing the History panel goes: the same page without the ":version"
 * param. The rest of the query is kept — `?thread=` is what keeps an open draft
 * open, and dropping it would silently leave the draft. `compare` only means
 * something while History is open, so it goes with it.
 */
export const historyClosedLocation = (
    route: RouteLocationNormalizedLoaded
): RouteLocationRaw => {
    const query = { ...route.query };
    delete query.compare;
    return {
        name: route.name,
        params: { ...route.params, version: undefined },
        query,
    };
};
